import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { getProfile } from '@/lib/profileApi';

// User ids whose account setup is known to be complete, so the profile is asked for once per session.
const setupDone = new Set();

export const markAccountSetupDone = (userId) => { setupDone.add(userId); };

// Sends a signed-in client to the first sign-in setup page until they have answered it.
// Fails open: if the profile cannot be read, the client is not locked out of the portal.
const RequireAccountSetup = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [state, setState] = useState({ userId: null, required: false });

  useEffect(() => {
    if (!user || setupDone.has(user.id)) return undefined;
    let cancelled = false;
    getProfile()
      .then((profile) => {
        if (cancelled) return;
        if (!profile.account_setup_required) setupDone.add(user.id);
        setState({ userId: user.id, required: Boolean(profile.account_setup_required) });
      })
      .catch(() => { if (!cancelled) setState({ userId: user.id, required: false }); });
    return () => { cancelled = true; };
  }, [user?.id]);

  if (!user || setupDone.has(user.id)) return children;
  if (state.userId !== user.id) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (state.required) return <Navigate to="/onboarding" state={{ from: location }} replace />;
  return children;
};

export default RequireAccountSetup;
